import { RequestStatus } from "@/hooks/useRequest";
import View from "@hfe/max-view";
import Text from "@hfe/max-text";
import LImage from "@max/leez-image";
import Image from "@hfe/max-image";
import ModalBaseContainer from "@max/leez-modal-base-container";
import TopView from "@max/leez-top-view";
import './index.scss';
import LoadingView from "@max/leez-loading-view";
import ActivityInvalid from "@/components/activity-invalid";
import { getFullScreenSize } from "@/utils/layout";
import { copyText, MTNewDigitalDisplayStyle } from "@/utils/common";
import RecyclerView from '@hfe/max-recyclerview';
import LButton from "@max/leez-button";
import { createElement, useState, useMemo } from "@max/max";
import { BID_MAP } from "@/const";
import { RankingListTheme } from "@/theme/main";
export var RankingTabType;
(function (RankingTabType) {
    RankingTabType["SPRINT"] = "sprint";
    RankingTabType["CONTRIBUTION"] = "contribution";
})(RankingTabType || (RankingTabType = {}));
const getSimpleWishContent = (wishOptions, wishCode = 0) => {
    var _a;
    return ((_a = wishOptions === null || wishOptions === void 0 ? void 0 : wishOptions.find(item => item.id === wishCode)) === null || _a === void 0 ? void 0 : _a.simpleContent) || '';
};
export default function RankingList(props) {
    var _a, _b, _c, _d, _e;
    const { rateHeight, rateSafeAreaMarginBottom } = getFullScreenSize();
    const [activeTab, setActiveTab] = useState(props.defaultTab || RankingTabType.CONTRIBUTION);
    const handleTabChange = (tab) => {
        var _a;
        if (tab !== activeTab) {
            setActiveTab(tab);
        }
        (_a = props === null || props === void 0 ? void 0 : props.lxReport) === null || _a === void 0 ? void 0 : _a.call(props, BID_MAP.REWORDS_TAB_MC, {
            tab_name: tab
        });
    };
    const currentStatus = activeTab === RankingTabType.SPRINT ? props.rankingStatus : props.contributionStatus || RequestStatus.SUCCESS;
    const currentHasMore = activeTab === RankingTabType.SPRINT ? props.hasMore : props.contributionHasMore || false;
    const loadMoreFunc = activeTab === RankingTabType.SPRINT ? props.loadMore : props.loadContribution || (() => { });
    // 渲染巅峰冲刺榜项
    const renderSprintItem = useMemo(() => {
        return (item, index) => {
            var _a;
            const rankNumber = index + 4;
            const isLastItem = index > 2 && index === ((_a = props === null || props === void 0 ? void 0 : props.rankingList) === null || _a === void 0 ? void 0 : _a.length) - 1;
            return <RecyclerView.Cell>
          <View key={`${item.groupId}-${index}`} style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                height: '135rpx',
                // width: '750rpx',
                padding: '0rpx 37rpx 24rpx 10rpx',
                marginRight: '37rpx',
                marginBottom: '24rpx'
            }}>
            <View style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'
            }}>
              <Text style={Object.assign(Object.assign({}, MTNewDigitalDisplayStyle), { color: '#111111', fontWeight: '700', fontSize: '36rpx', zIndex: 1, width: '68rpx', textAlign: 'center' })}>
                {rankNumber}
              </Text>
              <View style={{
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: '17rpx'
            }}>
                <View style={{
                width: '110rpx',
                height: '110rpx',
                borderRadius: '110rpx',
                overflow: 'hidden',
                borderWidth: '3rpx',
                borderColor: '#FFFFFF',
                position: 'relative'
            }}>
                  <Image source={{
                uri: item === null || item === void 0 ? void 0 : item.teamImg
            }} resizeMode="cover" style={{
                height: '110rpx',
                width: '110rpx'
            }}/>
                </View>
              </View>
              <Text numberOfLines={1} style={{
                color: '#111111',
                fontFamily: 'PingFang SC',
                fontWeight: '500',
                fontSize: '28rpx',
                zIndex: 1,
                maxWidth: props.isIncludeWishTask ? '184rpx' : '196rpx',
                wordSpacing: '0'
            }}>
                {item === null || item === void 0 ? void 0 : item.teamName}
              </Text>
            </View>
            <View style={{
                // width: props.isIncludeWishTask ? '350rpx' : '180rpx',
                flex: 1,
                zIndex: 1,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end'
            }}>
              <Text x-if={props.isIncludeWishTask} style={{
                fontWeight: '400',
                color: props.isIncludeWishTask && item.wishCode ? '#555555' : '#C2C2C2',
                fontFamily: 'PingFang SC',
                fontSize: '24rpx',
                zIndex: 1,
                width: '140rpx',
                textAlign: 'right',
                marginRight: '5rpx'
            }}>
                {item.wishCode ? `心愿: ${getSimpleWishContent(props.wishOptions, item.wishCode)}` : '未选择心愿'}
              </Text>
              
              <Text style={{
                fontWeight: '400',
                color: '#111111',
                fontFamily: 'PingFang SC',
                fontSize: '24rpx',
                zIndex: 1,
                maxWidth: '180rpx',
                textAlign: 'right'
            }}>
                Call值：{item.teamValue}
              </Text>
            </View>
            {!isLastItem && <View style={{
                width: '470rpx',
                height: '1rpx',
                backgroundColor: '#000000',
                opacity: 0.09,
                position: 'absolute',
                bottom: 0,
                right: '41rpx'
            }}/>}
          </View>
        </RecyclerView.Cell>;
        };
    }, [props.rankingList]);
    // 渲染队友贡献榜项
    const renderContributionItem = useMemo(() => {
        return (item, index) => {
            var _a;
            const rankNumber = index + 1;
            const isLastItem = index === ((_a = ((props === null || props === void 0 ? void 0 : props.contributionList) || [])) === null || _a === void 0 ? void 0 : _a.length) - 1;
            const isLeader = (item === null || item === void 0 ? void 0 : item.role) === 1;
            const hasNoContribution = Number(item === null || item === void 0 ? void 0 : item.teamValue) === 0;
            return <RecyclerView.Cell>
          <View key={`contribution-${index}`} style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                height: '158rpx',
                width: '750rpx',
                padding: '20rpx 37rpx 24rpx 10rpx'
            }}>
            <View style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'
            }}>
              <Text style={Object.assign(Object.assign({}, MTNewDigitalDisplayStyle), { color: '#111111', fontWeight: '700', fontSize: '36rpx', zIndex: 1, 
                // marginRight: '24rpx',
                width: '72rpx', textAlign: 'center' })}>
                {rankNumber}
              </Text>
              <View style={{
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: '17rpx'
            }}>
                <View style={{
                width: '110rpx',
                height: '110rpx',
                borderRadius: '110rpx',
                overflow: 'hidden',
                borderWidth: '3rpx',
                borderColor: '#FFFFFF',
                position: 'relative'
            }}>
                  <Image source={{
                uri: item === null || item === void 0 ? void 0 : item.avatar
            }} resizeMode="cover" style={{
                height: '104rpx',
                width: '104rpx'
            }}/>
                </View>
                {isLeader && <View style={{
                position: 'absolute',
                bottom: 0,
                backgroundColor: '#000000',
                borderRadius: '9rpx',
                paddingRight: '10rpx',
                paddingLeft: '10rpx',
                zIndex: 2
            }}>
                      <Text style={{
                color: '#FFFFFF',
                fontFamily: 'PingFang SC',
                fontSize: '18rpx',
                lineHeight: '26rpx',
                fontWeight: '500'
            }}>队长</Text>
                    </View>}
              </View>
              <Text numberOfLines={1} style={{
                color: '#111111',
                fontFamily: 'PingFang SC',
                fontWeight: '500',
                fontSize: '28rpx',
                zIndex: 1,
                maxWidth: hasNoContribution ? '160rpx' : '270rpx'
            }}>
                {item === null || item === void 0 ? void 0 : item.nickname}
              </Text>
            </View>
            {hasNoContribution ? <View style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'
                // marginRight: '17rpx',
            }} onClick={() => {
                var _a, _b;
                if (props === null || props === void 0 ? void 0 : props.pokeRemindText) {
                    copyText(props === null || props === void 0 ? void 0 : props.pokeRemindText);
                }
                (_a = props === null || props === void 0 ? void 0 : props.onInviteCall) === null || _a === void 0 ? void 0 : _a.call(props);
                (_b = props === null || props === void 0 ? void 0 : props.lxReport) === null || _b === void 0 ? void 0 : _b.call(props, BID_MAP.POKE_BTN_MC);
            }}>
                <Text style={{
                fontWeight: '400',
                color: '#C2C2C2',
                fontFamily: 'PingFang SC',
                fontSize: '24rpx',
                marginRight: '14rpx'
            }}>
                  未贡献{props.callValueDesc || 'Call值'}
                </Text>
                <View style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '559rpx',
                width: '160rpx',
                height: '60rpx'
            }}>
                  <Image source={{
                uri: RankingListTheme.PokeButton
            }} style={{
                width: '160rpx',
                height: '60rpx'
            }}/>
                </View>
              </View> : <Text x-if={(item === null || item === void 0 ? void 0 : item.teamValue) || Number(item === null || item === void 0 ? void 0 : item.teamValue) === 0} style={{
                fontWeight: '400',
                color: '#111111',
                fontFamily: 'PingFang SC',
                fontSize: '24rpx',
                zIndex: 1,
                textAlign: 'left',
                marginRight: '17rpx'
            }}>
                {`贡献${props.callValueDesc || 'Call值'}：${item === null || item === void 0 ? void 0 : item.teamValue}`}
              </Text>}
            {!isLastItem && <View style={{
                width: '470rpx',
                height: '1rpx',
                backgroundColor: '#000000',
                opacity: 0.09,
                position: 'absolute',
                bottom: 0,
                right: '41rpx'
            }}/>}
          </View>
        </RecyclerView.Cell>;
        };
    }, [props.contributionList]);
    // 判断当前列表是否有数据
    const hasListData = activeTab === RankingTabType.SPRINT ? Array.isArray(props === null || props === void 0 ? void 0 : props.rankingList) && ((_a = props === null || props === void 0 ? void 0 : props.rankingList) === null || _a === void 0 ? void 0 : _a.length) > 0 : Array.isArray(props === null || props === void 0 ? void 0 : props.contributionList) && ((_b = props === null || props === void 0 ? void 0 : props.contributionList) === null || _b === void 0 ? void 0 : _b.length) > 0;
    return <TopView>
    <ModalBaseContainer type="slide" visible={props === null || props === void 0 ? void 0 : props.rankingVisible} contentStyle={{
        height: 1312 > rateHeight * 0.8 ? `${rateHeight * 0.8}rpx` : '1312rpx'
    }}>
      <LImage source={{
        uri: RankingListTheme.BackgroundImage
    }} style={{
        width: '750rpx',
        height: '1312rpx'
    }} showAnimatioin={false}>
        <View className="ranking-list-title-container">
          <LImage source={{
        uri: RankingListTheme.TitleImage
    }} style={{
        width: '566rpx',
        height: '92rpx'
    }}/>
          <LImage source={{
        uri: RankingListTheme.CloseButton
    }} style={{
        width: '36rpx',
        height: '36rpx',
        position: 'absolute',
        right: '30rpx',
        top: '12rpx'
    }} onPress={props.onClose}/>
        </View>

        

        
        <View className="ranking-tab-container">
          <View className="ranking-tab-bg">
            <View className={`ranking-tab-slider ${activeTab === RankingTabType.SPRINT ? 'slider-left' : 'slider-right'}`}/>
            <View className={`ranking-tab-item ${activeTab === RankingTabType.SPRINT ? 'active' : ''}`} onClick={() => handleTabChange(RankingTabType.SPRINT)}>
              <Text className={`ranking-tab-text ${activeTab === RankingTabType.SPRINT ? 'active-text' : ''}`}>巅峰冲刺榜</Text>
            </View>
            <View className={`ranking-tab-item ${activeTab === RankingTabType.CONTRIBUTION ? 'active' : ''}`} onClick={() => handleTabChange(RankingTabType.CONTRIBUTION)}>
              <Text className={`ranking-tab-text ${activeTab === RankingTabType.CONTRIBUTION ? 'active-text' : ''}`}>队友贡献榜</Text>
            </View>
          </View>
        </View>

        {currentStatus === RequestStatus.LOADING ? <LoadingView showIcon showContent bgColorType="dark" level="medium" theme={{
        medium: {
            spacing: 15,
            textType: 'body4'
        }
    }} animate content={'加载排行中'}/> : hasListData ? <View style={{
        height: 1312 > rateHeight * 0.8 ? `${rateHeight * 0.8 - rateSafeAreaMarginBottom - 190}rpx` : `${1312 - rateSafeAreaMarginBottom - 190}rpx`
    }}>
                <RecyclerView onEndReached={props.loadType === 'scroll' ? loadMoreFunc : undefined} onEndReachedThreshold={props.loadType === 'scroll' ? 100 : undefined}>
                  <RecyclerView.Header>
                    {activeTab === RankingTabType.SPRINT && props.rankingList.length >= 3 && <View className="top-three-container">
                        <TopThreeItem teamInfo={props === null || props === void 0 ? void 0 : props.rankingList[1]} bg={RankingListTheme.Top2Background} borderColor="#FFE2BC" avatarBorderImage={RankingListTheme.Top2AvatarBorder} rankingImage={RankingListTheme.Top2RankingIcon} rankingImageStyle={{
        width: '115rpx',
        height: '77rpx',
        marginTop: '7rpx'
    }} callValueDesc={props.callValueDesc} wishOptions={props.wishOptions} isIncludeWishTask={props.isIncludeWishTask}/>
                        <TopThreeItem teamInfo={props === null || props === void 0 ? void 0 : props.rankingList[0]} style={{
        marginBottom: '34rpx',
        marginRight: '23rpx',
        marginLeft: '23rpx'
    }} bg={RankingListTheme.Top1Background} borderColor="#FFFADB" avatarBorderImage={RankingListTheme.Top1AvatarBorder} rankingImage={RankingListTheme.Top1RankingIcon} rankingImageStyle={{
        width: '100rpx',
        height: '67rpx',
        marginTop: '-20rpx',
        marginBottom: '-22rpx'
    }} callValueDesc={props.callValueDesc} wishOptions={props.wishOptions} isIncludeWishTask={props.isIncludeWishTask}/>
                        <TopThreeItem teamInfo={props === null || props === void 0 ? void 0 : props.rankingList[2]} bg={RankingListTheme.Top3Background} borderColor="#E1FAE8" avatarBorderImage={RankingListTheme.Top3AvatarBorder} rankingImage={RankingListTheme.Top3RankingIcon} rankingImageStyle={{
        width: '100rpx',
        height: '67rpx',
        marginTop: '-14rpx',
        marginBottom: '-20rpx'
    }} callValueDesc={props.callValueDesc} wishOptions={props.wishOptions} isIncludeWishTask={props.isIncludeWishTask}/>
                      </View>}
                  </RecyclerView.Header>
                  {activeTab === RankingTabType.SPRINT ? (_d = (_c = props === null || props === void 0 ? void 0 : props.rankingList) === null || _c === void 0 ? void 0 : _c.slice(3)) === null || _d === void 0 ? void 0 : _d.map((item, index) => renderSprintItem(item, index)) : (_e = ((props === null || props === void 0 ? void 0 : props.contributionList) || [])) === null || _e === void 0 ? void 0 : _e.map((item, index) => renderContributionItem(item, index))}
                  {currentStatus === RequestStatus.LOADING_MORE ? <LoadingView showIcon bgColorType="light" level="medium" theme={{
        medium: {
            spacing: 15,
            textType: 'body4'
        }
    }} style={{
        marginTop: '15rpx',
        marginBottom: '15rpx'
    }} animate content={'加载中'}/> : currentHasMore ? <View x-if={(props === null || props === void 0 ? void 0 : props.loadType) === 'click' && activeTab === RankingTabType.SPRINT} style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '10rpx',
        marginBottom: '55rpx'
    }}>
                          <LButton level='small2' onPress={loadMoreFunc} text={'加载更多'} style={{
        width: '200rpx'
    }}/>
                        </View> : <View x-if={activeTab === RankingTabType.SPRINT} style={{
        width: '750rpx',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '10rpx',
        marginBottom: '55rpx'
    }}>
                          <Text className="ranking-list-no-more-text">没有更多了～</Text>
                        </View>}
                </RecyclerView>
              </View> : <View style={{
        marginTop: '200rpx'
    }}>
                  <ActivityInvalid type="empty" text="暂无排行数据" color="#555555"/>
                </View>}
      </LImage>
    </ModalBaseContainer>
  </TopView>;
}
function TopThreeItem(props) {
    var _a;
    if (!props.teamInfo) {
        // 占位
        return <View style={{
            width: '212rpx',
            height: '275rpx'
        }}/>;
    }
    return <View style={props.style} className="top-three-item-container">
    <Image source={{
        uri: props.bg
    }} style={{
        width: '212rpx',
        height: props.isIncludeWishTask ? '305rpx' : '275rpx'
    }}/>
    <View style={{
        height: '275rpx',
        width: '212rpx',
        overflow: 'visible',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        position: 'absolute',
        top: 0,
        left: 0
    }}>
      
      <View style={{
        width: '116rpx',
        height: '116rpx',
        position: 'absolute',
        left: '51rpx',
        top: '-58rpx',
        overflow: 'visible'
    }}>
        <View style={{
        borderRadius: '116rpx',
        borderWidth: '3rpx',
        borderColor: props.borderColor,
        overflow: 'hidden'
    }}>
          <Image source={{
        uri: props.teamInfo.teamImg
    }} style={{
        width: '110rpx',
        height: '110rpx'
    }} resizeMode="cover"/>
        </View>
        <LImage source={{
        uri: props.avatarBorderImage
    }} style={{
        width: '43rpx',
        height: '32rpx',
        position: 'absolute',
        left: '35rpx',
        top: '-23rpx'
    }} showAnimatioin={false}/>
      </View>
      <Text numberOfLines={1} className="top-three-team-name">{props.teamInfo.teamName}</Text>
      <LImage source={{
        uri: props.rankingImage
    }} style={props.rankingImageStyle} resizeMode="contain" showAnimatioin={false}/>
      <Text x-if={props.isIncludeWishTask} className="top-three-call-value">{((_a = props.teamInfo) === null || _a === void 0 ? void 0 : _a.wishCode) ? `心愿：${getSimpleWishContent(props.wishOptions, props.teamInfo.wishCode)}` : ''}</Text>
      <View style={{
        display: 'flex',
        flexDirection: 'row'
    }}>
        
        <Text className="top-three-call-value">Call值：{props.teamInfo.teamValue}</Text>
      </View>
    </View>

  </View>;
}
